import React from 'react';

import { HistoryProps } from 'utils/history';
import YearbookDetailScreen from './YearbookDetailScreen';

export default (props: HistoryProps) => (
  <YearbookDetailScreen {...props} text={true} />
);
